import { Hand, Network, type LucideIcon } from "lucide-react"
import { type ComponentType, type CSSProperties } from "react"
import { BrainSideIcon } from "./icons/BrainSideIcon"
import { RoboticGripperIcon } from "./icons/RoboticGripperIcon"

// The four labor categories every chart in this folder visualizes.
// Centralizing these here keeps key/icon/label/default-color in lockstep
// across the donut, segmented bar, and descending bar variants.

export const LABOR_CATEGORY_KEYS = [
  "humansCog",
  "humansPhys",
  "aiCog",
  "robotPhys",
] as const

export type LaborCategoryKey = typeof LABOR_CATEGORY_KEYS[number]

type LaborMixIconProps = {
  size?: number
  strokeWidth?: number
  style?: CSSProperties
}

export type LaborMixIcon = LucideIcon | ComponentType<LaborMixIconProps>

// Default colors. Charts can override these per-category if they need a
// different palette (e.g. the descending bar variants tint robotPhys with
// the accent color rather than neutral grey).
export const LABOR_CATEGORY_COLORS: Record<LaborCategoryKey, string> = {
  humansCog: "#1a1a1a",
  humansPhys: "#737373",
  aiCog: "var(--accent)",
  robotPhys: "#8a8a8a",
}

// Default human-readable labels used by the tooltip and by charts that
// don't override them.
export const LABOR_CATEGORY_LABELS: Record<LaborCategoryKey, string> = {
  humansCog: "humans · cognitive",
  humansPhys: "humans · physical",
  aiCog: "AI · cognitive",
  robotPhys: "robots · physical",
}

// Icon shown in the tooltip and inside each chart segment/bar.
export const LABOR_CATEGORY_ICONS: Record<LaborCategoryKey, LaborMixIcon> = {
  humansCog: BrainSideIcon,
  humansPhys: Hand,
  aiCog: Network,
  robotPhys: RoboticGripperIcon,
}

// Off-white that all icons render as regardless of context.
export const LABOR_ICON_TINT = "#fffff8"
